module.exports = __webpack_public_path__ + "img/c08_buildingtechcompositebow_Normal_ua.e290b4c2.webp";